<template>
  <div class="tabs">
    <input
      class="input"
      name="tabs"
      type="radio"
      id="tab-1"
      checked="checked"
    />
    <label class="label" for="tab-1">Episod</label>
    <div class="panel">
      <div class="w-100" style="margin-bottom: 80px;">
        <div
          class="w-100 my-2"
          v-for="item_vod in episodeData"
          :key="item_vod.id"
        >
          <EpisodeCardMobile
            :id="item_vod.id"
            :image="item_vod.img_link"
            :title="item_vod.longTitle"
            :link="item_vod.redirect_link"
            :description="item_vod.data.description"
            :locked="lockedlist"
          />
        </div>
      </div>
      <!-- <div class="w-100">
        <p class="no-record-title">Tiada rekod dijumpai</p>
      </div> -->
    </div>
    <input class="input" name="tabs" type="radio" id="tab-2" />
    <label class="label" for="tab-2">Rancangan Popular</label>
    <div class="panel">
      <div class="w-100">
        <div class="container-fluid">
          <div class="row">
            <div
              class="col-6 col-sm-4 p-1 mb-3"
              v-for="item_vod in masthead_featured"
              :key="item_vod.id"
              @mouseover="mouseOver"
              @mouseout="mouseOver"
            >
              <vod-potrait-card
                :image="item_vod.img_link"
                :title="item_vod.longTitle"
                :link="item_vod.redirect_url"
                :latestTag="item_vod.shownewimage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import saluranKhas from "../../components/carousel/vod/v2/saluranTV.vue";
import timelineJadualMobile from "./timelineJadualMobile.vue";
import EpisodeCardMobile from "../cards/v2/episodeCardMobile.vue";
import vodPotraitCard from "../cards/v2/vodPotraitCard.vue";
export default {
  name: "vodTabsMobile",
  props: ["episodeData", "lockedlist"],
  data: function() {
    return {
      masthead_featured: [],
      hover: false,
    };
  },
  components: {
    EpisodeCardMobile,
    vodPotraitCard,
  },

  created: function() {
    this.$store.dispatch("fetchMastheadsFeatured", { self: this });
  },
  methods: {
    mouseOver: function() {
      this.hover = !this.hover;
    },
    goTo() {
      this.$router.push("/live/tv1");
    },
    filterMastheadFeatured() {
      //for latest video
      var vm = this;
      vm.masthead_featured = this.$store.state.masthead_featured.data;
      var store = [];
      vm.masthead_featured.forEach((item) => {
        var redirectLink = this.getAssetLink(item);
        item["img_link"] = this.rtmImgLinkFiltering(
          item.data.images,
          "320x426",
          "poster"
        );
        item["redirect_url"] = redirectLink;
        var timecompare = this.formatTimestamp(item.dateAvailability);
        item["shownewimage"] = timecompare;
        store.push(item);
      });

      vm.masthead_featured = store.slice(0, 8);
    },
  },
};
</script>

<style scoped>
h1 {
  margin: 0;
  font-family: "Bree Serif", serif;
  font-size: 36px;
}
p {
  margin-top: 20px;
  margin-bottom: 0;
  padding: 0;
  font-size: 20px;
  line-height: 1.5;
}
.tabs {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  max-width: 760px !important;
  max-height: 800px !important;
  background: #000;
  box-shadow: 0 48px 80px -32px rgba(0, 0, 0, 0.3);
}
.input {
  position: absolute;
  opacity: 0;
}
.label {
  width: 100%;
  padding: 16px 8px;
  background: #000;
  cursor: pointer;
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  transition: background 0.1s, color 0.1s;
}
.label:hover {
  background: #000;
}
.label:active {
  background: #000;
}
.input:focus + .label {
  z-index: 1;
}
.input:checked + .label {
  border-bottom: 2px solid #d9e021;
}
@media (max-width: 768px) {
  .label {
    width: auto;
  }
}
.panel {
  width: 100%;
  display: none;
  padding: 16px 0;
  position: relative;
  max-height: 700px;
  overflow: auto;
}
@media (max-width: 768px) {
  .panel {
    order: 99;
  }
}
.input:checked + .label + .panel {
  display: block;
}
</style>
